// extracted by mini-css-extract-plugin
module.exports = {"rehireModal":"rehireModal--jxxo1","rehireFooter":"rehireFooter--SIkyB","rehireText":"rehireText--AgPfT","card":"card--4RZ5w","isActive":"isActive--jNL8H"};